export default __webpack_public_path__ + "static/media/napa-logo_en.fc61cfa3.png";